<template>
  <v-app>
    <transition name="fade">
      <router-view />
    </transition>
    <modal name="modals-container" />
    <v-snackbar
      v-model="videoStreamErrorOpen"
      content-class="app-error-stream"
      top
      :timeout="10000"
      centered
    >
      <v-btn
        width="20px"
        height="20px"
        icon
        class="app-error-stream_close"
        @click="closeVideoStreamError"
      >
        <v-icon size="18" color="darken-2"> mdi-close </v-icon>
      </v-btn>
      <p>
        低遅延モードに失敗しました。<br />
        しばらく時間をあけて再度お試しください。
      </p>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AuthService from '@/services/auth.service';
import EventBus from '@/utils/eventBus';
import VideoService from '@/services/video.service';
import { isMaintenanceMode } from './services/common.service';
import { EventBusEvents } from './globals/enums';
import { Hub } from 'aws-amplify';
import { dialogService } from './services/dialog.service';

export default {
  name: 'App',
  data: () => ({
    authService: new AuthService(),
    videoService: new VideoService(),
    videoStreamErrorOpen: false,
    snackText: '',
    hubListenerCancelToken: null,
  }),
  computed: {
    ...mapState({
      snack: (state) => state.dialog.snacks,
    }),
    routeName() {
      return this.$route.name;
    },
    shouldFitHeight() {
      return (
        !(this.routeName || '').startsWith('help') &&
        !(this.routeName || '').startsWith('login')
      );
    },
  },
  watch: {
    snack(val) {
      this.snackText = val[val.length - 1];
      this.snackbar = true;
    },
  },
  mounted() {
    this.init();
    window.addEventListener('offline', () => {
      this.setNetworkOnline(false);
    });

    EventBus.on(
      EventBusEvents.VideoStreamErrorOpen,
      this.changeVideoStreamErrorOpen
    );

    window.addEventListener('online', () => {
      this.setNetworkOnline(true);
    });
    if (this.$route.query.testMode) {
      this.setTestMode(true);
    }
  },
  beforeDestroy() {
    EventBus.off(
      EventBusEvents.VideoStreamErrorOpen,
      this.changeVideoStreamErrorOpen
    );
    this.hubListenerCancelToken();
  },
  created() {
    this.authService.initLogin();
    this.start();
    this.getWebVersion();
    this.hubListenerCancelToken = Hub.listen('auth', (data) => {
      const { payload } = data;
      this.onAuthEvent(payload);
      console.log(
        'A new auth event has happened: ',
        data?.payload?.data?.username + ' has ' + data.payload.event
      );
    });
  },
  methods: {
    ...mapActions('common', [
      'start',
      'setNetworkOnline',
      'setTestMode',
      'getWebVersion',
    ]),
    onAuthEvent(payload) {
      switch (payload.event) {
        case 'tokenRefresh_failure':
          EventBus.emit(EventBusEvents.AuthFailureCleanup, {
            reason: 'Token refresh failed',
            timestamp: new Date().toISOString(),
            source: 'App.onAuthEvent',
          });
          dialogService.cognitoError({
            error: { code: 'default' },
          });
          break;

        case 'signOut':
          break;

        default:
          break;
      }
    },
    changeVideoStreamErrorOpen(status) {
      this.videoStreamErrorOpen = status;
    },
    closeVideoStreamError() {
      this.videoStreamErrorOpen = false;
    },
    async init() {
      const maintenanceMode = await isMaintenanceMode();
      if (maintenanceMode) {
        this.$router.push({ name: 'maintenance' });
      }
    },
  },
};
</script>
<style lang="scss">
.app-error-stream {
  color: red;
  padding: 20px;
  &_close {
    position: absolute;
    top: 8px;
    right: 8px;
  }
}
.v-snack {
  .v-snack__wrapper.v-sheet.theme--dark {
    padding: 0;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.7);
    margin-top: 30px;
    p {
      margin-bottom: 0;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
    }
  }
}
</style>
